export default {
    actions: {
        isThisMainPage(ctx) {
            const loc = window.location.pathname.split("/");
            loc[1] === ""
                ? ctx.commit("updateIsMainPage", true)
                : ctx.commit("updateIsMainPage", false);
        }
    },

    mutations: {
        updateCatalog(state, foo) {
            state.catalog = foo;
        },

        updateCatalogSecond(state, foo) {
            state.catalogSecond = foo;
        },

        updateCatalogThird(state, foo) {
            state.catalogThird = foo;
        },

        updateAllBrands(state, foo) {
            state.brands = foo;
        },

        updateCatalogVisible(state, foo) {
            state.catalogVisible = foo;
        },

        updateIsMainPage(state, foo) {
            state.isThisMainPage = foo;
        }
    },

    state() {
        return {
            catalog: [],
            catalogSecond: [],
            catalogThird: {},
            brands: [],
            catalogVisible: false,
            isThisMainPage: false
        };
    },

    getters: {
        catalogArray(state) {
            return state.catalog;
        },

        catalogArraySecond(state) {
            return state.catalogSecond;
        },

        getCatalogThird(state) {
            return state.catalogThird;
        },

        allBrands(state) {
            return state.brands;
        },

        getCatalogVisible(state) {
            return state.catalogVisible;
        },

        getIsThisMainPage(state) {
            return state.isThisMainPage;
        }
    }
};
